import React, { useState, useEffect } from 'react';
import HeaderStartSession from '../header-start-session/header-start-session';
import { graphql, useStaticQuery } from 'gatsby';
import MegaMenu from '../mega-menu/mega-menu';
import NavMenuMobile from '../nav-menu-mobile/nav-menu-mobile'
import NavMenu from '../nav-menu/nav-menu';
import useHomeLinkMode from '../../../hooks/useHomeLinkMode';
import { StaticImage } from 'gatsby-plugin-image'
import './header.scss';

const Header = props => {

  const { homeLink } = useHomeLinkMode();
  const resultQuery = useStaticQuery(
    graphql`
        query{
            allContentfulPequeninTransversal(filter: {titulo: {eq: "Transversal"}}) {
                    nodes {
                      node_locale
                      redireccionChat
                      logo{
                        description
												file{
                          url
                        }
                      }
                      logo2{
                        description
												file{
													url
                        }
                      }
                    menu {
                        opcionesDelMenu {
                            nombreDeLaOpcion
                            redireccionDeLaOpcion
                            opcionesSubmenu {
                                nombreDeLaOpcion
                                redireccionDeLaOpcion
                                imagenDeLaOpcion {
                                  file {
                                    url
                                  }
                                  description
                                }
                                opcionesSubmenu {
                                nombreDeLaOpcion
                                redireccionDeLaOpcion
                                imagenDeLaOpcion {
                                  description
                                  gatsbyImageData(formats: [AUTO, WEBP], placeholder: BLURRED)
                                }
                                }
                            }
                        }
                    }
                    }
                }
        } 
    
    `
  )

  const queryCountry = resultQuery.allContentfulPequeninTransversal.nodes.filter(e => e.node_locale === process.env.LOCALE)[0]
  const menuOptions = queryCountry.menu.opcionesDelMenu
  const chatRedirection = queryCountry.redireccionChat
      
  useEffect(() => {
    let lastScrollTop = window.pageYOffset;
    window.addEventListener('scroll', function (ev) {
      let header = document.getElementById('f-m-header')
      let logo = document.getElementById('f-m-header-logo')
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ((scrollTop > lastScrollTop) && (scrollTop > 100)) {
        header.classList.add("f-m-header__hide")
        logo.classList.add("f-m-header-logo__hide")
      } else {
        header.classList.remove("f-m-header__hide")
        logo.classList.remove("f-m-header-logo__hide")
      }
      lastScrollTop = scrollTop;
    });
  }, []);

  const [activeMegaMenu, setActiveMegaMenu] = useState(null)
  const [activeMenuMobile, setActiveMenuMobile] = useState(false)

  return (
    <header className="f-m-header" id="f-m-header">
      <div className="f-m-header-logo-container"
        id="f-m-header-logo"
        onClick={() => location.href = homeLink}
      >
        <img
          className="f-m-header-logo f-m-header-logo--mobile"
          src={queryCountry.logo2.file.url}
          alt={queryCountry.logo2.description}
          // loading="eager"
          placeholder="blurred"
        />
        <img
          className="f-m-header-logo"
          src={queryCountry.logo.file.url}
          alt={queryCountry.logo.description}
          // loading="eager"
          placeholder="blurred"
        />
      </div>
      <NavMenu className="f-m-header-nav-menu" activeMenu={props.activeMenu} menuOptions={menuOptions} activeMegaMenu={activeMegaMenu} setActiveMegaMenu={setActiveMegaMenu} />
      {activeMenuMobile && <NavMenuMobile activeMenu={props.activeMenu} menuOptions={menuOptions} setActiveMenuMobile={setActiveMenuMobile} chatRedirection={chatRedirection} activeMenuMobile={activeMenuMobile} setActiveShoppingModal={props.setActiveShoppingModal} />}
      {activeMegaMenu && <MegaMenu subMenu={activeMegaMenu} />}
      <HeaderStartSession className="f-m-header-start-session" setActiveMenuMobile={setActiveMenuMobile} />
    </header>
  )
}

export default Header;